import { Anchor, Image } from '@mantine/core';
import type { FC } from 'react';
import logoUrl from '#website/assets/logo.svg';

export type ZalaLogoProps = {
	size?: number | { base: number; md: number };
};

export const ZalaLogo: FC<ZalaLogoProps> = ({ size = 36 }) => {
	return (
		<Anchor href={'/'}>
			<Image src={logoUrl} alt={'Zala'} w={size} h={size} />
		</Anchor>
	);
};
